<div class="darkTheme-{{ darkTheme }} largeTheme-{{ largeTheme }}">

  <!-- <div class="accessibility">
    <button
      [class]="darkTheme ? 'btn btn-sm btn-outline-light mr-2' : 'btn btn-sm btn-outline-dark mr-2'"
      (click)="darkTheme = !darkTheme">
        <i class="far fa-adjust mr-2"></i>{{ darkTheme ? 'Light Background' : 'Dark Background' }}
    </button>

    <button 
      [class]="darkTheme ? 'btn btn-sm btn-outline-light' : 'btn btn-sm btn-outline-dark'"
      (click)="largeTheme = !largeTheme">
        <i class="far fa-text-size mr-2"></i>{{ largeTheme ? 'Decrease Text Size' : 'Increase Text Size' }}
    </button>
  </div> -->
  <!-- <app-banner [message]="bannerMessage"></app-banner> -->

  <div class="min-vh-100 d-flex">
    <div class="container">
      <div class="row mt-10 mb-10">
        <div class="col-12">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>

</div>
